import React, { useEffect, useState } from "react";
import { Table, Switch } from "antd";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteAStakeholder, getStakeholder, resetState, } from "../features/StakeholderSlice";
import CustomModal from "../components/CustomModal";

const columnsTemplate = (showModal) => [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Company Name",
    dataIndex: "cname",
  },
  {
    title: "Document",
    dataIndex: "document",
    render: (document) => (
      <img src={document} alt="Document" style={{ width: 50, height: 50 }} />
    ),
  },
  {
    title: "Action",
    dataIndex: "action",
    render: (_, record) => (
      <>
        
        {/* Delete button */}
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(record.id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  },
];

const Stakeholderlist = () => {
  const [open, setOpen] = useState(false);
  const [StakeholderId, setStakeholderId] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetState());
    dispatch(getStakeholder());
  }, [dispatch]);

  const getStakeholderState = useSelector(
    (state) => state.Stakeholder.Stakeholders
  );

  const showModal = (id) => {
    setOpen(true);
    setStakeholderId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };


  const deleteNews = (id) => {
    dispatch(deleteAStakeholder(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getStakeholder());
    }, 100);
  };

  const data1 = getStakeholderState.map((stakeholder, index) => ({
    key: index + 1,
    id: stakeholder._id,
    name: `${stakeholder.fname} ${stakeholder.lname}`,
    cname: stakeholder.cname,
    document: stakeholder.Document[0],
    isVerified: stakeholder.isverifyed,
  }));

  const columns = columnsTemplate(showModal);

  return (
    <div>
      <h3 className="mb-4 title">Verifyed Stakeholder List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(StakeholderId);
        }}
        title="Are you sure you want to delete this Stakeholder?"
      />
    </div>
  );
};

export default Stakeholderlist;
